import { TFunction } from 'i18next';

export const getHPIContinuityText = (
    eligibilityStatus: boolean,
    resetDate: string,
    t: TFunction,
) => {
    if (eligibilityStatus) {
        return {
            hText: t('videoSessions:sessions_widget.hpi_eligible.header', { resetDate }),
            bText: t('videoSessions:sessions_widget.button.schedule_session'),
            bDisabled: false,
        };
    }
    return {
        hText: t('videoSessions:sessions_widget.out_of_sessions.header'),
        bText: t('videoSessions:sessions_widget.button.schedule_session'),
        bDisabled: true,
    };
};
